module.exports = __webpack_public_path__ + "main/assets/public/masthead/menu.bb4dc29cfeb135ee.svg";